import jQuery from 'jquery';
const $ = jQuery;

window.jQuery = $;
window.$ = $;

import 'cssuseragent';
import 'jquery.easing';

// import PerfectScrollbar from 'perfect-scrollbar';

import Swiper, { Pagination, Autoplay } from 'swiper';

// configure Swiper to use modules
Swiper.use([Pagination, Autoplay]);

// import ImgLazyLoad from './module/img-lazy-load';

document.oncontextmenu = function () {
  return false;
}

// if (navigator.platform == "iPad" ||        // -iOS12
//   (navigator.platform == "MacIntel" &&   // iPadOS
//     navigator.userAgent.indexOf("Safari") != -1 &&
//     navigator.userAgent.indexOf("Chrome") == -1 &&
//     navigator.standalone !== undefined)) {
// }

class mgdApp {
  constructor() {

    $('body, html').animate({
      scrollTop: 0
    }, 1);

    this.loadCompleteApp = false;
    this.progressBarCompelte = false;
    function noscroll(e) {
      e.preventDefault();
    }
    document.addEventListener('touchmove', noscroll, { passive: false });
    document.addEventListener('wheel', noscroll, { passive: false });

    this.loadWaitInterval = setInterval(() => {
      if (this.loadCompleteApp && this.progressBarCompelte) {
        clearInterval(this.loadWaitInterval);
        // 完了した時にしたい処理
        // window.scrollTo(0, 0);

        setTimeout(() => {
          $('.mgdJs--headerBase').css({
            'opacity': '1',
          });
          document.removeEventListener('touchmove', noscroll);
          document.removeEventListener('wheel', noscroll);
        }, 800);
      }

    }, 1000 / 30);
  }

  mgdReady() {

    $('.mgdJs--headerBase').css({
      'opacity': '0',
      // 'background': 'black',
    });

    setTimeout(() => {
      $('body, html').animate({
        scrollTop: 0
      }, 1);

      this.progressBarCompelte = true;
      $('.LoderKeyvisual').fadeOut(500, () => {
        setTimeout(() => {
          $('.LoderKeyvisual').remove();
        }, 500);
      });
    }, 3000);

  }
  mgdLoad() {
    $('body, html').animate({
      scrollTop: 0
    }, 1);

    this.loadCompleteApp = true;
    // window.scrollTo(0, 0);

    $('.TitleLocation').each(function (index) {
      index = index + 1;
      $(this).attr('data-id', "TitleLocation-" + index).attr('id', "TitleLocation-" + index);
    });
  }
}

class ScrollIdApp {
  constructor() { }
  ScrollIdAppClick() {
    $('a[href^="#"], button[href^="#"]').click(function () {
      console.log('test');
      // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
      var adjust = -80;
      // スクロールの速度（ミリ秒）
      var speed = 400;
      // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
      var href = $(this).attr("href");
      // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
      var target = $(href == "#" || href == "" ? 'html' : href);
      // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
      var position = target.offset().top + adjust;
      // スムーススクロール linear（等速） or swing（変速）
      $('body,html').animate({ scrollTop: position }, speed, 'swing');
      return false;
    });
  }
}

let MgdApp = new mgdApp();
let scrollIdApp = new ScrollIdApp();

$('document').ready(() => {
  console.log('v47.10');
  MgdApp.mgdReady();
});

$(window).on('load', () => {

  MgdApp.mgdLoad();
  scrollIdApp.ScrollIdAppClick();

  $('.DirectorComment').click(function () {
    $('html,body').animate({ scrollTop: 0 }, '0.1');
  })
});